import { cn } from 'src/utils/className';

type Variant = 'primary' | 'success' | 'warning' | 'error' | 'info';

const variantClasses: Record<Variant, string> = {
  primary: 'bg-primary-100 border-primary',
  success: 'bg-success-100 border-success',
  warning: 'bg-warning-100 border-warning',
  error: 'bg-error-100 border-error',
  info: 'bg-info-100 border-info',
};

export function InfoPanel({
  title,
  description,
  variant = 'primary',
  icon,
  className,
  dataTestId,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  variant?: Variant;
  icon?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}) {
  return (
    <div
      role="alert"
      data-testid={dataTestId}
      className={cn(
        'border-l-4 rounded-lg p-6 space-y-2 animate-fade-in-up',
        variantClasses[variant],
        className,
      )}
    >
      <div className="flex items-start gap-3">
        {icon && (
          <div className="mt-0.5 text-primary flex-shrink-0">{icon}</div>
        )}
        <div className="space-y-1">
          <h3 className="font-semibold text-neutral-700 text-base">{title}</h3>
          {description && (
            <p className="text-sm text-neutral-600">{description}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default InfoPanel;
